export const colors = {
    blue: {
        value: '#2469f5',
        isImportant: false,
    },
    hoverBlue: '#2160e0',
    acidBlue: '#1B61F9',
    activityGreen: '#28c75d',
    activityGreenLight: '#EAFFF1',
    activityGrey: '#c7c7c7',
    activityOrange: '#ff8e2d',
    activityRed: '#f9303f',
    backgroundLightGrey: '#f8f9fb',
    backgroundGrey: '#F0F3F7',
    backgroundGreyAccent: '#E3E9F2',
    backgroundGreyStrongAccent: '#D1D9E4',
    white: '#ffffff',
    black: '#333333',
    red: '#f44e4e',
    defaultBorder: '#E9ECF3',
    controlBorder: '#E0E2E8',
    controlBorderFocus: '#5F94FF',
    controlBorderHover: '#D7D9DF',
    dividerDarkerGrey: '#d8d8d8',
    dividerGrey: '#F0F3F7',
    iconGrey: '#B3C3DB',
    iconMark: '#ff297a',
    linkBlue: '#005BD1',
    linkBlueHover: '#00357a',
    notificationRed: '#ff002f',
    quotaBlue: '#5F71FE',
    quotaRed: '#FC2C38',
    quotaYellow: '#FDCF50',
    textGrey: '#999999',
    landingPrimary: '#3420a3',
    basicTextColor: '#333333',

    bgGreenatom: '#515050',
    bgAccentGreenatom: '#6C6C6C',
    bgX5: '#fab57a',
    textColorX5: '#31393C',
    bgAccentX5: '#FFBE93',
    bg1c: '#FBEEB1',
    bgAccent1c: '#F5D94C',
    bgRCloud: '#3D92EB',
    bgAccentRCloud: '#74B8FF',
    bgMegafon: '#57B565',
    bgAccentMegafon: '#7ACA86',
    siteLinks1c: '#9F8F44',

    errorLight: '#FFE2E1',
    error: '#FC2C38',
    successLight: '#DFFFEA',
    success: '#28C75D',
    warningLight: '#FFEACC',
    warning: '#FFA930',
};
